import { render, staticRenderFns } from "./Triage.vue?vue&type=template&id=7d1d9022&scoped=true"
import script from "./Triage.vue?vue&type=script&lang=js"
export * from "./Triage.vue?vue&type=script&lang=js"
import style0 from "./Triage.vue?vue&type=style&index=0&id=7d1d9022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1d9022",
  null
  
)

export default component.exports